import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92081ea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter" }

import { t } from '@/plugins/i18n'
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { request } from '@/config/request/interceptors'


export default /*#__PURE__*/_defineComponent({
  props: ['row'],
  setup(__props) {

const props = __props


const saveCustomSupplierName = (row: any) => {
  const { shopProductSkuId } = row
  const value = customSupplierName.value.trim()
  editing.value = false
  if (value !== props.row?.customSupplierName) {
    request.order.shop.productSkuUpdateCustomerProductSupplierName({ customSupplierName: value, shopProductSkuId }).then((res: any) => {
      if (!res.success) return
      ElMessage.success(t('保存成功'))
      row.customSupplierName = value
    })
  } else {
    customSupplierName.value = row.customSupplierName ?? ''
  }
}

const editing = ref(false)
const input = ref()
const show = () => {
  editing.value = true
  input.value.focus()
}

const customSupplierName = ref(props.row?.customSupplierName ?? '')

watch(() => props.row?.customSupplierName, (v) => {
  customSupplierName.value = v
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tooltip, {
      placement: "top",
      effect: "light",
      disabled: !customSupplierName.value
    }, {
      content: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(customSupplierName.value), 1)
      ]),
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("a", {
          class: "show-one-line",
          onClick: show
        }, [
          _createTextVNode(_toDisplayString(customSupplierName.value) + " ", 1),
          _createVNode(SvgIcon, {
            name: "pencil",
            style: {"color":"var(--acolor)"}
          })
        ], 512), [
          [_vShow, !editing.value]
        ])
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        ref: (_value, _refs) => {
          _refs['input'] = _value
          input.value = _value
        },
        modelValue: customSupplierName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customSupplierName).value = $event)),
        size: "small",
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (saveCustomSupplierName(__props.row))),
        maxlength: "100"
      }, null, 8, ["modelValue"])
    ], 512), [
      [_vShow, editing.value]
    ])
  ], 64))
}
}

})